import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import MicNoneOutlinedIcon from "@mui/icons-material/MicNoneOutlined";
import { MdOutlinePsychology } from "react-icons/md";
import { PiTreeStructureDuotone } from "react-icons/pi";
import { RiMoneyRupeeCircleLine } from "react-icons/ri";

const items = [
    {
        icon: <MdOutlinePsychology fontSize="40px" />,
        title: "Sales Psychology Mastery",
        text: "Understand how buyers think, decide, and respond during high-value sales conversations.",
    },
    {
        icon: <PiTreeStructureDuotone fontSize="40px" />,
        title: "Structured Conversation",
        text: "Learn frameworks that guide buyer discussions with clarity, confidence, and control",
    },
    {
        icon: <RiMoneyRupeeCircleLine fontSize="40px" />,
        title: "Revenue  Control Systems",
        text: "Build sales processes that create consistent performance instead of unpredictable results.",
    },
];

const SalesOrganaization = () => {
    return (
        <Box
            sx={{

                py: 6,
                px: { md: 10, xs: 10 },
            }}
        >
            <Box sx={{ mb: 4 }}>
                <Typography
                    variant="h3"
                    component="span"
                    sx={{
                        color: "#fff",
                        fontSize: { xs: '30px', md: "35px" },
                        fontWeight: 700,
                        letterSpacing: 2,
                        mr: 1,
                    }}
                >
                    What Will Change In Your
                </Typography>

                <Typography
                    variant="h1"
                    sx={{
                        background:
                            "linear-gradient(90deg, #ffffff 0%, #d4af37 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        position: "relative",
                        display: "inline-block",
                        fontWeight: 700,
                        fontSize: { xs: "50px", md: "auto" },
                        "&::after": {
                            content: '""',
                            position: "absolute",
                            bottom: "0px",
                            left: 0,
                            width: "100%",
                            height: "10px",
                            background: "rgb(177 177 177 / 50%)",
                            borderRadius: "4px",
                        },
                    }}
                >
                    Sales Organisation?
                </Typography>
            </Box>

         
            <Grid container spacing={3} alignItems="center" mt={4}>
                {/* LEFT SIDE */}
                <Grid item xs={12} md={6}>
                    {items.map((item, index) => {
                        const isEven = index % 2 === 0;

                        return (
                            <Box
                                key={index}
                                sx={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    mb: 8,
                                }}
                            >

                                <Box
                                    sx={{
                                        minHeight: 70,
                                        minWidth: 70,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "1px solid #f9a21e",
                                        borderRadius: "5px",
                                        mr: "30px",
                                        position: "relative",
                                        zIndex: 1,
                                        color: "#f9a21e",
                                        transition: "all .3s ease",

                                        /* 🔥 EXACT CORNER LOGIC */
                                        "&::before": {
                                            content: '""',
                                            position: "absolute",
                                            width: "30px",
                                            height: "30px",
                                            background: "#000",
                                            zIndex: -1,

                                            ...(isEven
                                                ? { bottom: "-10px", right: "-10px" }   // 1st & 3rd
                                                : { top: "-10px", left: "-10px" }),    // 2nd
                                        },

                                        "&:hover": {
                                            borderColor: "#fff",
                                            color: "#fff",
                                        },
                                    }}
                                >
                                    {item.icon}
                                </Box>

                                <Box>
                                    <Typography variant="h5" sx={{ color: "#fff", mb: 2, textAlign: 'start' }}>
                                        {item.title}
                                    </Typography>

                                    <Typography sx={{ color: "#aaa", maxWidth: 380, textAlign: 'start' }}>
                                        {item.text}
                                    </Typography>
                                </Box>
                            </Box>
                        );
                    })}
                </Grid>

                {/* RIGHT SIDE (Demo Illustration) */}
                <Grid item xs={12} md={6}>
                    <Box
                        sx={{
                            position: "relative",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        {/* Yellow Circle */}
                        {/* <Box
                            sx={{
                                position: "absolute",
                                width: 350,
                                height: 350,
                                background: "#f9a21e",
                                borderRadius: "50%",
                                left: 50,
                                zIndex: 1,
                            }}
                        /> */}

                       
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default SalesOrganaization;